exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#notfound-page {\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: bottom;\n  min-height: 100vh; }\n  #notfound-page header {\n    padding: 0px 0px;\n    min-height: 80px; }\n    #notfound-page header .close {\n      float: right;\n      position: absolute;\n      right: 15px; }\n  #notfound-page .page-title {\n    /* Create your account!: */\n    font-family: Open Sans;\n    font-weight: bold;\n    font-size: 28px;\n    color: #efbb40;\n    text-align: left; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/views/NotFound/styles.scss
// module id = 1143
// module chunks = 0